import * as React from 'react';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { routes } from '../../../../../config/routes';
import { Logo } from '../../../../../components/app/logo/logo';
import { HeaderBackButton } from '../../../../../components/app/header/back-button/header-back-button';
import { HeaderPinSharedPortfolioButton } from '../../../../../components/app/header/pin-shared-portfolio-button/header-pin-shared-portfolio-button';

export const HeaderHorizontalShared: React.FC = () => {
    const rootStore = useRootStore();
    const { showHeaderBar } = rootStore.themeStore;

    return (
        <div
            className={`fixed left-0 z-[900] flex h-screen w-[23.2rem] flex-col border-r border-border bg-surface ${
                showHeaderBar ? 'top-bar' : 'top-0'
            }`}
        >
            <div className="flex items-center gap-xsmall border-b border-border pl-small md:gap-vsmall md:pl-medium vl:py-[2.7rem]">
                <Logo href={routes.app.index} inApp />
            </div>
            <div className="flex flex-col gap-vsmall p-vsmall">
                <HeaderPinSharedPortfolioButton />
                <HeaderBackButton />
            </div>
        </div>
    );
};
